import ApiClient from "../api/apiClient";

const REGISTER = "/auth/register";
const ACTIVATE_ACCOUNT = "/auth/activate-account/";
const RESEND_EMAIL = "/auth/resend-email";
const LOGIN = "/auth/login";
const FORGOT_PASSWORD = "/auth/forgot-password";
const RESET_PASSWORD = "/auth/reset-password/";
const DEACTIVATE_FORGOT_PASSWORD = "/auth/deactivate-forgot-password/";
const ADMIN_LOGIN = "/user/admin-login";
const VERIFY_ORGANIZATION = "/organizations/verify"

const registerUser = (data) => {
  return ApiClient.post(REGISTER, data);
};

const activateAccount = (token) => {
  const url = ACTIVATE_ACCOUNT + token;
  return ApiClient.post(url);
};

const resendEmail = (data) => {
  const url = RESEND_EMAIL;
  return ApiClient.post(url, data);
};

const login = (data) => {
  const url = LOGIN;
  return ApiClient.post(url, data);
};

const forgotPassword = (data) => {
  const url = FORGOT_PASSWORD;
  return ApiClient.post(url, { ...data, panel: 2 });
};

const resetPassword = ({ token, data }) => {
  const url = RESET_PASSWORD + token;
  return ApiClient.post(url, data);
};

const deactivateForgotPassword = (token) => {
  const url = DEACTIVATE_FORGOT_PASSWORD + token;
  return ApiClient.get(url);
};

const adminLogin = ({ email, token }) => {
  const url = ADMIN_LOGIN;
  return ApiClient.post(
    url,
    { email }, // This is the request body
    {
      headers: {
        Authorization: `Bearer ${token}` // Correctly structured headers
      }
    }
  );
};

const verifyOrganization = (id) => {
  return ApiClient.get(VERIFY_ORGANIZATION+'/'+id);
};
export const authServie = {
  registerUser,
  activateAccount,
  resendEmail,
  login,
  forgotPassword,
  resetPassword,
  deactivateForgotPassword,
  adminLogin,
  verifyOrganization
};
